import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import { Link } from "react-scroll";

const useStyles = makeStyles(() => {
  return {
    navBackground: {
      backgroundColor: "#fff",
      color: "#000",
    },
    typo: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 500,
    },
  };
});

const Navbar = () => {
  const classes = useStyles();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  return (
    <>
      <AppBar position="fixed" className={classes.navBackground} elevation={3}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: "none", md: "flex" }, flexGrow: 1 }}
            >
              LOGO
            </Typography> */}
            <img
              src="loo 1.svg"
              style={{ display: { xs: "none", md: "block" } }}
            />
            <Typography sx={{ flexGrow: 1 }}></Typography>
            {/* <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              LOGO
            </Typography> */}
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Link to="home" smooth={true} duration={1000}>
                <Button
                  sx={{
                    my: 2,
                    color: "white",
                    display: "block",
                    textTransform: "none",
                    paddingLeft: 2,
                    paddingRight: 2,
                  }}
                >
                  <Typography className={classes.typo}>Home</Typography>
                </Button>
              </Link>
              <Link to="about" smooth={true} duration={1000}>
                <Button
                  sx={{
                    my: 2,
                    color: "white",
                    display: "block",
                    textTransform: "none",
                  }}
                >
                  <Typography className={classes.typo}>About</Typography>
                </Button>
              </Link>
              <Link to="web" smooth={true} duration={1000}>
                <Button
                  sx={{
                    my: 2,
                    color: "white",
                    display: "block",
                    textTransform: "none",
                  }}
                >
                  <Typography className={classes.typo}>Web</Typography>
                </Button>
              </Link>
              <Link to="ux" smooth={true} duration={1000}>
                <Button
                  sx={{
                    my: 2,
                    color: "white",
                    display: "block",
                    textTransform: "none",
                    paddingRight: 4,
                  }}
                >
                  <Typography className={classes.typo}>UX</Typography>
                </Button>
              </Link>
              <Link to="letsconnect" smooth={true} duration={1000}>
                <Button
                  variant="outlined"
                  sx={{
                    my: 2,
                    color: "white",
                    textTransform: "none",
                    borderColor: "#001899",
                    borderWidth: 1,
                  }}
                >
                  <Typography className={classes.typo}>Lets Connect</Typography>
                </Button>
              </Link>
            </Box>
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <MenuItem>
                  <Link to="home" smooth={true} duration={1000}>
                    <Typography className={classes.typo}>Home</Typography>
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to="about" smooth={true} duration={1000}>
                    <Typography className={classes.typo}>About</Typography>
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to="web" smooth={true} duration={1000}>
                    <Typography className={classes.typo}>Web</Typography>
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to="ux" smooth={true} duration={1000}>
                    <Typography className={classes.typo}>UX</Typography>
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to="letsconnect" smooth={true} duration={1000}>
                    <Button
                      variant="outlined"
                      sx={{
                        color: "white",
                        textTransform: "none",
                        borderColor: "#001899",
                        borderWidth: 1,
                      }}
                    >
                      <Typography className={classes.typo}>
                        Lets Connect
                      </Typography>
                    </Button>
                  </Link>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Navbar;
